import { Provider, useSelector } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Auth from "./layout/Auth";
import Main from "./layout/Main";
import routes from "./routes";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

if (process.env.NODE_ENV === "production") {
    Sentry.init({
        dsn: "https://1e91d535c5b880528d0107d987de4409@o4507571489210368.ingest.de.sentry.io/4509054927634512",
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}
function App() {
    console.log("env", process.env.REACT_APP_NODE_ENV);
    return (
        <>
            <BrowserRouter>
                <Switch>
                    {routes.map((route) => {
                        switch (route.layout) {
                            case "main":
                                return (
                                    <Route
                                        exact
                                        path={`/${route.layout}` + route.path}
                                    >
                                        <Main>
                                            <route.component />
                                        </Main>
                                    </Route>
                                );
                            case "auth":
                                return (
                                    <Route
                                        exact
                                        path={`/${route.layout}` + route.path}
                                    >
                                        <Auth>
                                            <route.component />
                                        </Auth>
                                    </Route>
                                );
                        }
                    })}
                    <Redirect to="/auth/login" />
                </Switch>
            </BrowserRouter>
        </>
    );
}

export default process.env.NODE_ENV === "production"
    ? Sentry.withErrorBoundary(App, {
          fallback: (
              <div className="d-flex flex-column align-items-center justify-content-center text-danger py-5">
                  <div className="fw-bold text-center fs-1">
                      Something went wrong. Please try again later. 🚨
                  </div>
              </div>
          ),
      })
    : App;
